








































































import Vue from 'vue'
import moment from 'moment-timezone'
import NeedsAttention from '@/components/care-team-dashboard/NeedsAttention.vue'
import PatientUpdates from '@/components/care-team-dashboard/PatientUpdates.vue'
import PatientWatchList from '@/components/care-team-dashboard/PatientWatchList.vue'
import ProgramStats from '@/components/care-team-dashboard/ProgramStats.vue'
import IsGeneratingExportDialog from '@/components/dialog/IsGeneratingExportDialog.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import {
  ActionNames as PatientWithEventActionNames,
  GetterNames as PatientWithEventGetterNames,
} from '@/store/modules/patient-with-events/keys'
import {
  ActionNames as PatientNoteActionNames,
  GetterNames as PatientNoteGetterNames,
} from '@/store/modules/patient-note/keys'
import {
  ActionNames as WatchListActionNames,
  GetterNames as WatchListGetterNames,
} from '@/store/modules/watch-list/keys'
import { ActionNames as PatientActionNames } from '@/store/modules/patient/keys'
import { timeout } from '@/utils/time'
import { FlatWatchList } from '@/store/modules/watch-list/getters'
import { PATIENT_NOUN } from '@/constants/app-variables'
import { generatePdfFromHtml } from '@/utils/pdf-export'
import { ExportDialogs } from '@/constants/exports'
import { Timeouts } from '@/constants/timeouts'

export default Vue.extend({
  components: {
    NeedsAttention,
    PatientUpdates,
    PatientWatchList,
    ProgramStats,
    IsGeneratingExportDialog,
  },
  data() {
    return {
      loadedContent: false,
      loadedSiteStats: false,
      watchListLoadings: [],
      patientNoun: PATIENT_NOUN,
      isGeneratingExport: false,
      isGeneratingExportDialogText: ExportDialogs.Pdf,
    }
  },
  computed: {
    ...mapGetters({
      siteStatses: `${ModuleNames.siteStats}/${SiteStatsGetterNames.siteStatses}`,
      watchLists: `${ModuleNames.watchList}/${WatchListGetterNames.watchingWatchLists}`,
      patientRecentNotesGroupByPatientId: `${ModuleNames.patientNotes}/${PatientNoteGetterNames.patientRecentNotesGroupByPatientId}`,
      patientWithUrgentEvents: `${ModuleNames.patientWithEvents}/${PatientWithEventGetterNames.patientWithUrgentEvents}`,
      patientWithNewChangesEvents: `${ModuleNames.patientWithEvents}/${PatientWithEventGetterNames.patientWithNewChangesEvents}`,
    }),
    ...mapState(ModuleNames.patientWithEvents, ['patientWithEvents']),
    ...mapState(ModuleNames.patientNotes, ['patientNotes']),
    watchListExcludingRecentUpdatedPatients(): FlatWatchList[] {
      const havingEventsPatientIds = [
        ...this.patientWithUrgentEvents.map(p => p.id),
        ...this.patientWithNewChangesEvents.map(p => p.id),
      ]
      return this.watchLists.filter(watchList => !havingEventsPatientIds.includes(watchList.patientId))
    },
    pdfPatientUpdateTitle() {
      return `Agartee Dashboard Patient Updates ${moment().format('DD-MM-YYYY HH-MM-A')}`
    },
  },
  mounted(): void {
    this.fetchContent()
    this.fetchSiteStats()
  },
  methods: {
    ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    ...mapActions(ModuleNames.patientWithEvents, [PatientWithEventActionNames.getPatientWithEvents]),
    ...mapActions(ModuleNames.patientNotes, [PatientNoteActionNames.getPatientNotes]),
    ...mapActions(ModuleNames.watchList, [
      WatchListActionNames.getWatchLists,
      WatchListActionNames.patchWatchList,
      WatchListActionNames.postWatchList,
    ]),
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    async fetchContent() {
      this.loadedContent = false
      await Promise.all([
        this[PatientWithEventActionNames.getPatientWithEvents](),
        this[PatientNoteActionNames.getPatientNotes](),
        this[WatchListActionNames.getWatchLists](),
        this[PatientActionNames.getPatients](),
      ])
      this.loadedContent = true
    },
    async fetchSiteStats() {
      this.loadedSiteStats = false
      await Promise.all([this[SiteStatsActionNames.getSiteStatses]()])
      this.loadedSiteStats = true
    },
    async patchWatchList(payload): Promise<void> {
      this.watchListLoadings.push(payload.id)
      await this[WatchListActionNames.patchWatchList](payload)
      await timeout(1000)
      await this[WatchListActionNames.getWatchLists]()
      this.watchListLoadings = this.watchListLoadings.filter(id => id !== payload.id)
    },
    async exportPatientUpdatesToPdf() {
      this.isGeneratingExport = true
      await generatePdfFromHtml({
        filename: this.pdfPatientUpdateTitle,
        source: this.$refs['pdfPatientUpdates'],
        orientation: 'portrait',
      })
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
  },
})
